import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentPopupVisible = createSelector(
  (state: AppState) => state.ai.popup,
  popup => popup.isVisible,
)
